// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { NgxLoggerLevel } from "ngx-logger";

export const environment = {
    production: false,
    //++urlserv: 'http://localhost:55958',
    //urlserv: 'http://localhost:52080',
    //+++urlserv: 'http://213.8.209.141:52080',

    urlserv: "https://AutomationTest.ishur.biz", //https
    //+++urlserv: 'https://localhost:44332/', //https iis express

    //+++ urlservbeautech: 'http://localhost:30938',
    //+++urlservbeautech: 'http://213.8.209.141:52090',

    urlservbeautech: "https://webapitest.optimus.co.il", //https

    logLevel: NgxLoggerLevel.WARN,
    serverLogLevel: NgxLoggerLevel.INFO,

    urlsocketio: "localhost:3000/diary",
    urlonlinecountersocket: "https://sockettest.ishur.biz/",
};

export const activeTemplates = [
    true, // Visit
    true, // Birthday
    true, // MeetingCreate
    true, // MeetingCancel
    true, // MeetingDateChange
    true, // MeetingTimeChange
    true, // ThanksForRecomandation
    true, // ThanksForVisit
    true, // EndDay
    true, // SendCash
];

export const screenId = {
    Automation: {
        // 1
        mainsms: 101,
        templatesms: 102,
    },
    Customers: {
        // 2
        clientbase: 201,
        custcardview: 205,
    },
    Calendar: {
        // 3
        calendarview: 301,
    },
};

export const expandedSidebar = true;

// Set to true to enable Eruda console in production (for debugging on mobile devices)
export const isErudaEnabled = false;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

// http://localhost:5000/mainsms?email=prod@gmail.com

// http://localhost:5000/mainsms?email=not@gmail.com
